import { Component, OnInit, AfterViewInit, Input, ViewChild, QueryList, ViewChildren, Inject, Output, EventEmitter, OnChanges, ElementRef, OnDestroy, AfterViewChecked } from '@angular/core';
import { SalesOrder, SubSalesOrder, MarketingIP, PmTechnicalIP, PurchasePOIP, PlanningIP, PurchaseMaterialReceiptIP, ProductionIP, QualityIP, ScmIP, EnggDrawIP, EnggProcureIP, StoreIP, LogisticIP, SSOStatus, SaveStatusObj, Equipment, FunctionStatus, PlannedDateToken, ActualDateToken, SuborderNumbers, PartialDelivery, RequestDateToken, EnggProcFileUploads, GenFileUploads, DataSheetIP, DatasheetNumbers, DataSheetSubOrderIP, UserType } from '../../../shared/misc-classes';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyTabChangeEvent as MatTabChangeEvent } from '@angular/material/legacy-tabs';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormControl as FormControl } from '@angular/forms';
import { DataService } from '../../../shared/dataservice.service';
import { DsExportService, DsExportHeaderInfo, RevisionExportHeaderInfo, RevisionExportPayload } from '../../../shared/ds-export.service';
import { RevisionFieldDelta, RevisionHandlerService } from '../../../shared/revision-handler.service';
import { DS_TAB_CONFIG } from '../../../shared/ds-export-config';

@Component({
  selector: 'data-sheet-suborder',
  templateUrl: './data-sheet-suborder.component.html',
  styleUrls: ['./data-sheet-suborder.component.css']
})
export class DataSheetSuborderComponent implements OnChanges, OnInit {


  selectedIndex = 0;
  @Input() soLockObtained:boolean;

  @Input() loadCounter: SalesOrder;
  @Input() subOrderObj: SubSalesOrder;

  @Input() dataSheetSubOrderObj: DataSheetSubOrderIP;

  @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();
  @Output() deleteSubsaleorder: EventEmitter<SaveStatusObj> = new EventEmitter();

  disableForm: boolean = true;
  readonlyAccess: boolean = false;
  inputDisableMessage: string = 'NA';

  landingPage: string = '';
  subSoNo!: string;
  accessLevel: Array<UserType> = [];

  private _currentFetchedPath: string | null = null;

  @ViewChildren('stepper') stepper: any;

  selectedDepartmentIndex = 0;
  selectedRevisionIndex = 0;

  // Live (current) datasheet captured on first ngOnChanges; restored when user clicks
  // the current-version tab after viewing a historical revision.
  private _liveDatasheet: DataSheetSubOrderIP | null = null;
  // Per-blob-path in-memory cache of fetched historical revisions.
  private _fetchedCache: { [path: string]: DataSheetSubOrderIP } = {};
  // Per-deltaPath in-memory cache of loaded revision delta blobs.
  private _deltaCache: { [deltaPath: string]: RevisionFieldDelta[] } = {};
  fetchingPath: string | null = null;
  // Track whether we're viewing a fetched (historical) revision
  private isViewingFetched: boolean = false;

  private _activeRevisionDeltas: RevisionFieldDelta[] = [];
  private _activeFieldPaths: Set<string> = new Set<string>();
  private _activeSectionKeys: Set<string> = new Set<string>();
  private _lastRenderSignature = '';
  private _sectionKeyByTabIndex: { [idx: number]: string } = {};

  constructor(
    public _dataService: DataService,
    public dialog: MatDialog,
    private _dsExportService: DsExportService,
    private _revisionHandler: RevisionHandlerService,
    private _host: ElementRef
  ) {
    for (const tab of DS_TAB_CONFIG) {
      this._sectionKeyByTabIndex[tab.tabIndex] = tab.sectionKey;
    }
  }

  get isLockObtained():boolean{
    return this.soLockObtained;
  }

  get isReadOnlyView(): boolean {
    return this.isViewingFetched;
  }

  get isRevisionIntelligenceEnabled(): boolean {
    return this._revisionHandler.isRevisionIntelligenceEnabled(this._liveDatasheet || this.dataSheetSubOrderObj);
  }

  get canShowRevisionExportButton(): boolean {
    if (!this.isCurrentVersionTab(this.selectedRevisionIndex)) return false;
    if (!this.isRevisionIntelligenceEnabled) return false;
    return this.hasAnyRevisionChangesEstimate();
  }

  // Show 22 sections only when: (1) on current version tab, OR (2) viewing fetched historical revision
  get shouldShowSections(): boolean {
    const versionsLen = this._liveDatasheet?.versions?.length || 0;
    const onCurrentTab = this.selectedRevisionIndex === versionsLen;
    return onCurrentTab || this.isViewingFetched;
  }

  get effectiveData(): DataSheetSubOrderIP {
    if (this.isViewingFetched && this._currentFetchedPath && this._fetchedCache[this._currentFetchedPath]) {
      return this._fetchedCache[this._currentFetchedPath];
    }
    return this._liveDatasheet || this.dataSheetSubOrderObj;
  }

  getVersionCreatorName(versionEntry: any): string {
    // Primary: Use createdByName if it exists (new revisions)
    if (versionEntry && versionEntry.createdByName) {
      return versionEntry.createdByName;
    }
    return '';
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.refreshRevisionHighlightState();
  }

  ngAfterViewChecked(): void {
    const signature = [
      this.selectedRevisionIndex,
      this.selectedDepartmentIndex,
      this.isViewingFetched ? 1 : 0,
      this._currentFetchedPath || '',
      this._activeRevisionDeltas.length
    ].join('|');

    if (signature !== this._lastRenderSignature) {
      this._lastRenderSignature = signature;
      this.applyRevisionMarkers();
      return;
    }
    // signature is unchanged, reapply markers when the delta icon has been lost.
    if (this._activeRevisionDeltas.length > 0) {
      const container: HTMLElement | null = this._host.nativeElement.querySelector('.tab-content');
      if (container && !container.querySelector('.rev-delta-icon')) {
        this.applyRevisionMarkers();
      }
    }
  }

  ngOnDestroy(): void {
    this.clearRevisionMarkers();
  }

  ngOnChanges() {
    this.disableForm = true;

    //always use ORIGINAL input
    if (this.dataSheetSubOrderObj) {
      this._liveDatasheet = this.dataSheetSubOrderObj;
    }

    // prevent tab reset after fetch
    if (this.selectedRevisionIndex === 0) {
      this.selectedRevisionIndex = this.dataSheetSubOrderObj?.versions?.length || 0;
    }

    this.accessLevel = [
      UserType.SUPER_ADMIN,
      UserType.PROJECT_MANAGEMENT,
      UserType.HOD_PROJECT_MANAGEMENT,
      UserType.MECHANICAL_ENGINEERING,
      UserType.ELECTRICAL_ENGINEERING
    ];

    if (this.soLockObtained == false) {
      this.inputDisableMessage = "You can't Edit, Sale Order Lock NOT obtained.";
    }
    else if (!this.dataSheetSubOrderObj?.isInputEnabled) {
      this.inputDisableMessage = "This form is not yet enabled";
    }
    else if (!this.dataSheetSubOrderObj?.isDatasheetEditable) {
      this.inputDisableMessage = "This form is LOCKED and is NOT EDITABLE.";
    }
    else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
    }

    if (this._dataService.hasReadOnlyAccess) {
      this.readonlyAccess = true;
    }

    this.refreshRevisionHighlightState();
  }

  dataSheetStepChange(_ent) {
    this.selectedDepartmentIndex = _ent.selectedIndex;
    this.applyRevisionMarkers();
  }

  updateDS(_evnt: SaveStatusObj, _indx: number) {
    if (this.updateDatasheet) {
      let _tmpIndx = this.subOrderObj.parentSORef.subSalesOrder
        .findIndex((subSo) => subSo.subOrderNoId === this.subOrderObj.subOrderNoId);

      this.selectedIndex = _tmpIndx;
      _evnt.ssoIndex = _tmpIndx;
      this.updateDatasheet.emit(_evnt);
    }
  }

  getStatusCSS(_status: FunctionStatus): string {
    if (_status == FunctionStatus.WAITING_FOR_PREV) return "tab-legend white-legend";
    if (_status == FunctionStatus.WAITING_FOR_USER_INPUT) return "tab-legend grey-legend";
    if (_status == FunctionStatus.SUBMITTED_INCOMPLETE) return "tab-legend yellow-legend";
    if (_status == FunctionStatus.SUBMITTED_COMPLETE) return "tab-legend green-legend";
    if (_status == FunctionStatus.SUBMITTED_WAITING_RESPONSE) return "tab-legend blue-legend";
    if (_status == FunctionStatus.NOT_SUBMITTED_BUT_READY) return "tab-legend yellow-legend";
    return "tab-legend white-legend";
  }

  subOrderTabChanged(_evnt: MatTabChangeEvent) {
    this.selectedDepartmentIndex = 0;
    this.selectedIndex = _evnt.index;
    this.applyRevisionMarkers();
  }

  

  // public getSubOrderEnable():boolean{
  //   return this.loadCounter.isSubOrdesEnabled;
  // }

  exportDatasheet(): void {
    const mkt = this.dataSheetSubOrderObj.parentSORef.marketingIP;
    const headerInfo: DsExportHeaderInfo = {
      formatNo: 'EPMV-AIS-HOM-001',
      customerName: mkt.customerName || '',
      projectName: mkt.projectName || '',
      switchboard: (this.subOrderObj && this.subOrderObj.pmTechSubSalesOrder) ? this.subOrderObj.pmTechSubSalesOrder.boardname || '' : '',
      abbReference: (mkt.salesOrderNo || '') + (this.subOrderObj ? ' - ' + this.subOrderObj.subOrderNoId : '')
    };
    this._dsExportService.exportDatasheet(headerInfo, this.dataSheetSubOrderObj);
  }

  exportForCustomer(): void {
    const mkt = this.dataSheetSubOrderObj.parentSORef.marketingIP;
    const headerInfo: DsExportHeaderInfo = {
      formatNo: 'EPMV-AIS-HOM-001',
      customerName: mkt.customerName || '',
      projectName: mkt.projectName || '',
      switchboard: (this.subOrderObj && this.subOrderObj.pmTechSubSalesOrder) ? this.subOrderObj.pmTechSubSalesOrder.boardname || '' : '',
      abbReference: (mkt.salesOrderNo || '') + (this.subOrderObj ? ' - ' + this.subOrderObj.subOrderNoId : '')
    };
    this._dsExportService.exportForCustomer(headerInfo, this.dataSheetSubOrderObj);
  }

  async exportRevisionInfo(): Promise<void> {
    const deltas = await this.collectAllRevisionDeltas(true);
    if (!deltas.length) {
      this._dataService.openSnackbar('Revision', 'No revision changes available for export.');
      return;
    }

    const mkt = this.dataSheetSubOrderObj.parentSORef.marketingIP;
    const now = new Date();
    const headerInfo: RevisionExportHeaderInfo = {
      formatNo: 'EPMV-AIS-HOM-001',
      customerName: mkt.customerName || '',
      projectName: mkt.projectName || '',
      switchboard: (this.subOrderObj && this.subOrderObj.pmTechSubSalesOrder) ? this.subOrderObj.pmTechSubSalesOrder.boardname || '' : '',
      abbReference: (mkt.salesOrderNo || '') + (this.subOrderObj ? ' - ' + this.subOrderObj.subOrderNoId : ''),
      currentRevision: this._liveDatasheet?.currentVersion || this.dataSheetSubOrderObj?.currentVersion || '',
      generatedDate: now.toISOString()
    };

    const revisionSet = new Set<string>();
    const fieldPathSet = new Set<string>();
    const sectionSet = new Set<string>();
    for (const d of deltas) {
      if (d.revision) revisionSet.add(d.revision);
      if (d.fieldPath) fieldPathSet.add(d.fieldPath);
      if (d.sectionKey) sectionSet.add(d.sectionKey);
    }

    const payload: RevisionExportPayload = {
      summary: {
        totalRevisions: revisionSet.size,
        totalFieldsModified: fieldPathSet.size,
        totalImpactedSections: sectionSet.size,
        latestRevision: headerInfo.currentRevision,
        generatedBy: this._dataService.userName || '',
        generatedDate: now.toISOString()
      },
      deltas
    };

    this._dsExportService.exportRevisionSummary(headerInfo, payload);
  }

   revisionTabChanged(_evnt: MatTabChangeEvent) {
    this.selectedRevisionIndex = _evnt.index;

    const versionsLen = this._liveDatasheet?.versions?.length || 0;

    //clear fetched state
    this.isViewingFetched = false;
    this._currentFetchedPath = null;

    if (_evnt.index === versionsLen) {
      this.restoreLiveDatasheet();
    }

    this.refreshRevisionHighlightState();
  }

  isCurrentVersionTab(idx: number): boolean {
    const versionsLen = this._liveDatasheet?.versions?.length || 0;
    return idx === versionsLen;
  }

  async onFetchRevision(version: any) {
    if (!version || !version.path) return;
    if (this.fetchingPath) return;

    if (this._fetchedCache[version.path]) {
      this._currentFetchedPath = version.path;
      this.isViewingFetched = true;
      this.refreshRevisionHighlightState();
      return;
    }

    this.fetchingPath = version.path;

    this._dataService.getDatasheetVersion(version.path).subscribe(
      (resp: any) => {
        this.fetchingPath = null;

        if (!resp || resp.status !== 'OK' || !resp.content) {
          this._dataService.openSnackbar('Revision', `Fetch failed for ${version.version}`);
          return;
        }

        try {
          const json = JSON.parse(resp.content);
          const restored = DataSheetSubOrderIP.getObj(json);

          if (this._liveDatasheet) {
            restored.versions = this._liveDatasheet.versions;
            restored.currentVersion = this._liveDatasheet.currentVersion;
            restored.parentSORef = this._liveDatasheet.parentSORef;
            restored.parentSubSORef = this._liveDatasheet.parentSubSORef;
          }

          this._fetchedCache[version.path] = restored;

          this._currentFetchedPath = version.path;
          this.isViewingFetched = true;
          this.refreshRevisionHighlightState();

          console.log(`[Fetch] Loaded ${version.version}`);
        } catch (e) {
          console.error('Failed to parse fetched revision', e);
          this._dataService.openSnackbar('Revision', `Fetch failed for ${version.version}`);
        }
      },
      (err: any) => {
        this.fetchingPath = null;
        console.error('Fetch revision failed', err);
        this._dataService.openSnackbar('Revision', `Fetch failed for ${version.version}`);
      }
    );
  }

  private applyFetched(ds: DataSheetSubOrderIP) {
    this.isViewingFetched = true;
    console.log('[applyFetched] Fetched revision applied (in-memory only)');
  }

  private restoreLiveDatasheet() {
    if (!this._liveDatasheet) return;

    this.isViewingFetched = false;
    this._currentFetchedPath = null;
    this.refreshRevisionHighlightState();
  }

  isSectionImpacted(tabIndex: number): boolean {
    if (!this.isRevisionIntelligenceEnabled) return false;
    const key = this._sectionKeyByTabIndex[tabIndex];
    if (!key) return false;
    return this._activeSectionKeys.has(key);
  }

  private hasAnyRevisionChangesEstimate(): boolean {
    const ds = this._liveDatasheet || this.dataSheetSubOrderObj;
    if (!ds || !Array.isArray(ds.versions)) return false;

    const hasMetaChanges = ds.versions.some(v =>
      !!v?.deltaPath
    );
    if (hasMetaChanges) return true;

    return ds.versions.length > 0 && ds.currentVersion && ds.currentVersion !== 'Rev-0';
  }

  private async refreshRevisionHighlightState(): Promise<void> {
    if (!this.isRevisionIntelligenceEnabled) {
      this._activeRevisionDeltas = [];
      this._activeFieldPaths = new Set<string>();
      this._activeSectionKeys = new Set<string>();
      this.applyRevisionMarkers();
      return;
    }

    const versions = (this._liveDatasheet?.versions || this.dataSheetSubOrderObj?.versions || []) as any[];
    const versionsLen = versions.length;

    // When user clicks "Fetch" on a revision, isViewingFetched=true and _currentFetchedPath is set
    if (this.isViewingFetched && this._currentFetchedPath) {
      const fetchedVersionIndex = versions.findIndex(v => v.path === this._currentFetchedPath);
      if (fetchedVersionIndex >= 0 && fetchedVersionIndex < versionsLen) {
        const fetchedVersion = versions[fetchedVersionIndex];
        const previousVersion = fetchedVersionIndex > 0 ? versions[fetchedVersionIndex - 1] : null;
        const deltas = await this.getVersionDeltas(fetchedVersion, previousVersion);
        this.setActiveDeltas(deltas);
        return;
      }
    }

    // Load deltas for revision tab (historical revisions selected via tab)
    if (this.selectedRevisionIndex < versionsLen) {
      const selectedVersion = versions[this.selectedRevisionIndex];
      if (!selectedVersion || this.selectedRevisionIndex === 0) {
        this._activeRevisionDeltas = [];
        this._activeFieldPaths = new Set<string>();
        this._activeSectionKeys = new Set<string>();
        this.applyRevisionMarkers();
        return;
      }
      const previousVersion = versions[this.selectedRevisionIndex - 1];
      const deltas = await this.getVersionDeltas(selectedVersion, previousVersion);
      this.setActiveDeltas(deltas);
      return;
    }

    // Current version tab: show cumulative changes from all revisions
    const consolidated = await this.collectAllRevisionDeltas(false);
    this.setActiveDeltas(consolidated);
  }

  private setActiveDeltas(deltas: RevisionFieldDelta[]): void {
    this._activeRevisionDeltas = Array.isArray(deltas) ? deltas : [];
    this._activeFieldPaths = new Set<string>();
    this._activeSectionKeys = new Set<string>();

    for (const d of this._activeRevisionDeltas) {
      if (d.fieldPath) this._activeFieldPaths.add(d.fieldPath);
      if (d.sectionKey) this._activeSectionKeys.add(d.sectionKey);
    }

    this.applyRevisionMarkers();
    Promise.resolve().then(() => this.applyRevisionMarkers());
  }

  private async collectAllRevisionDeltas(includeCurrentTransition: boolean): Promise<RevisionFieldDelta[]> {
    const ds = this._liveDatasheet || this.dataSheetSubOrderObj;
    if (!ds || !Array.isArray(ds.versions)) return [];

    const all: RevisionFieldDelta[] = [];

    // Per-version deltas: load from deltaPath blob or dynamic snapshot comparison
    for (let i = 0; i < ds.versions.length; i++) {
      const version = ds.versions[i];
      const previousVersion = i > 0 ? ds.versions[i - 1] : null;
      
      let deltas = await this.getVersionDeltas(version, previousVersion);
      // (before the fix that changed buildRevisionChanges to use ds.currentVersion)
      if (deltas && deltas.length > 0 && version.version) {
        const firstDeltaRev = deltas[0].revision;
        if (firstDeltaRev && firstDeltaRev !== version.version) {
          deltas = deltas.map(d => ({...d, revision: version.version}));
        }
      }
      
      if (deltas && deltas.length) {
        all.push(...deltas);
      }
    }

    if (includeCurrentTransition && ds.versions.length > 0) {
      const latestHistorical = await this.ensureRevisionLoaded(ds.versions[ds.versions.length - 1].path);
      const currentJson = ds.getJson();
      if (latestHistorical) {
        const currentDeltas = this._revisionHandler.buildRevisionChanges(
          latestHistorical.getJson(),
          currentJson,
          ds.currentVersion || '',
          this._dataService.userName || '',
          new Date()
        );
        all.push(...currentDeltas);
      }
    }

    const dedupe = new Map<string, RevisionFieldDelta>();
    for (const d of all) {
      const key = `${d.revision}|${d.fieldPath}|${d.oldValue}|${d.newValue}`;
      if (!dedupe.has(key)) dedupe.set(key, d);
    }
    return Array.from(dedupe.values());
  }

  private ensureRevisionLoaded(path: string): Promise<DataSheetSubOrderIP | null> {
    if (!path) return Promise.resolve(null);
    if (this._fetchedCache[path]) return Promise.resolve(this._fetchedCache[path]);

    return new Promise<DataSheetSubOrderIP | null>((resolve) => {
      this._dataService.getDatasheetVersion(path).subscribe(
        (resp: any) => {
          if (!resp || resp.status !== 'OK' || !resp.content) {
            resolve(null);
            return;
          }
          try {
            const json = JSON.parse(resp.content);
            const restored = DataSheetSubOrderIP.getObj(json);
            if (this._liveDatasheet) {
              restored.versions = this._liveDatasheet.versions;
              restored.currentVersion = this._liveDatasheet.currentVersion;
              restored.parentSORef = this._liveDatasheet.parentSORef;
              restored.parentSubSORef = this._liveDatasheet.parentSubSORef;
            }
            this._fetchedCache[path] = restored;
            resolve(restored);
          } catch (_e) {
            resolve(null);
          }
        },
        (_err: any) => resolve(null)
      );
    });
  }

  private ensureDeltaLoaded(deltaPath: string): Promise<RevisionFieldDelta[] | null> {
    if (!deltaPath) return Promise.resolve(null);
    if (this._deltaCache[deltaPath]) return Promise.resolve(this._deltaCache[deltaPath]);

    return new Promise<RevisionFieldDelta[] | null>((resolve) => {
      this._dataService.getDatasheetVersion(deltaPath).subscribe(
        (resp: any) => {
          if (!resp || resp.status !== 'OK' || !resp.content) {
            resolve(null);
            return;
          }
          try {
            const parsed = JSON.parse(resp.content);
            const arr: RevisionFieldDelta[] = Array.isArray(parsed)
              ? parsed
              : (Array.isArray(parsed?.deltas) ? parsed.deltas : []);
            this._deltaCache[deltaPath] = arr;
            resolve(arr);
          } catch (_e) {
            resolve(null);
          }
        },
        (_err: any) => resolve(null)
      );
    });
  }

  private async getVersionDeltas(version: any, previousVersion: any): Promise<RevisionFieldDelta[]> {
  if (!version) return [];
  if (version.deltaPath) {
    const blob = await this.ensureDeltaLoaded(version.deltaPath);
    if (blob !== null) {
      return blob;
    }
  }

  // Fallback: Dynamic snapshot comparison (requires previousVersion to compare against)
  if (!previousVersion) {
    return [];
  }

  const currentSnap = await this.ensureRevisionLoaded(version.path);
  const previousSnap = await this.ensureRevisionLoaded(previousVersion.path);
  if (!currentSnap || !previousSnap) {
    return [];
  }

  const deltas = this._revisionHandler.buildRevisionChanges(
    previousSnap.getJson(),
    currentSnap.getJson(),
    version.version || '',
    version.createdByName || '',
    version.createdDate || new Date()
  );
    return deltas;
  }

  private applyRevisionMarkers(): void {
    this.clearRevisionMarkers();
    if (!this._activeRevisionDeltas.length) return;

    const sectionKey = this._sectionKeyByTabIndex[this.selectedDepartmentIndex];
    if (!sectionKey) return;

    const container = this._host.nativeElement.querySelector('.tab-content');
    if (!container) return;

    const deltas = this._activeRevisionDeltas.filter(d => d.sectionKey === sectionKey);
    for (const delta of deltas) {
      this.applyMarkerForDelta(container, delta);
    }
  }

  private applyMarkerForDelta(container: HTMLElement, delta: RevisionFieldDelta): void {
    const fieldKey = delta.field || '';
    const indexMatch = /\[(\d+)\]\.[^.]+$/.exec(delta.fieldPath || '');
    const rowIndex = indexMatch ? Number(indexMatch[1]) : -1;

    if (fieldKey) {
      const controls = Array.from(container.querySelectorAll(`[name="${fieldKey}"]`));
      if (controls.length > 0) {
        if (rowIndex >= 0 && controls[rowIndex]) {
          this.decorateControl(controls[rowIndex] as HTMLElement);
        } else if (rowIndex < 0) {
          controls.forEach(c => this.decorateControl(c as HTMLElement));
        }
      }
    }

    const normalizedLabel = this.normalizeLabel(delta.fieldLabel || '');
    if (!normalizedLabel) return;

    const formFields = Array.from(container.querySelectorAll('mat-form-field')) as HTMLElement[];
    const exactMatches: HTMLElement[] = [];
    const looseMatches: HTMLElement[] = [];
    for (const ff of formFields) {
      const labelNode = ff.querySelector('mat-label');
      const labelText = this.normalizeLabel(labelNode ? labelNode.textContent || '' : '');
      if (!labelText) continue;
      if (labelText === normalizedLabel) {
        exactMatches.push(ff);
      } else if (labelText.includes(normalizedLabel)) {
        looseMatches.push(ff);
      }
    }

    const matched = exactMatches.length > 0 ? exactMatches : looseMatches;
    if (rowIndex >= 0 && matched[rowIndex]) {
      this.decorateControl(matched[rowIndex]);
    } else if (rowIndex < 0) {
      matched.forEach(m => this.decorateControl(m));
    }

    // Note fields are outside mat-form-field in most sections; match note labels
    // and highlight the corresponding textarea in the same note block.
    if (fieldKey === 'sectionNotePM' || fieldKey === 'sectionNoteEE' || fieldKey === 'sectionNoteME') {
      const labels = Array.from(container.querySelectorAll('label')) as HTMLElement[];
      const targetPrefix = fieldKey === 'sectionNotePM' ? 'pmnote' : fieldKey === 'sectionNoteEE' ? 'eenote' : 'menote';
      for (const lbl of labels) {
        const lblNorm = this.normalizeLabel(lbl.textContent || '');
        if (!lblNorm.startsWith(targetPrefix)) continue;

        lbl.classList.add('rev-delta-label');
        if (!lbl.querySelector('.rev-delta-icon')) {
          const icon = document.createElement('span');
          icon.className = 'rev-delta-icon';
          icon.textContent = ' 🚩';
          lbl.append(icon);
        }

        const noteBlock = (lbl.closest('.mid-note') as HTMLElement) || (lbl.parentElement as HTMLElement);
        if (noteBlock) {
          const ta = noteBlock.querySelector('textarea') as HTMLElement;
          if (ta) {
            this.decorateControl(ta);
          }
        }
      }
    }
  }

  private decorateControl(controlEl: HTMLElement): void {
    const fieldRoot = controlEl.closest('mat-form-field') as HTMLElement || controlEl;
    fieldRoot.classList.add('rev-delta-control');

    const label = fieldRoot.querySelector('mat-label') as HTMLElement;
    if (label) {
      label.classList.add('rev-delta-label');
      if (!label.querySelector('.rev-delta-icon')) {
        const icon = document.createElement('span');
        icon.className = 'rev-delta-icon';
        icon.textContent = ' 🚩';
        label.append(icon);
      }
    }
  }

  private clearRevisionMarkers(): void {
    const host: HTMLElement = this._host.nativeElement;
    const ctrls = Array.from(host.querySelectorAll('.rev-delta-control')) as HTMLElement[];
    ctrls.forEach(c => c.classList.remove('rev-delta-control'));

    const labels = Array.from(host.querySelectorAll('.rev-delta-label')) as HTMLElement[];
    labels.forEach(l => l.classList.remove('rev-delta-label'));

    const icons = Array.from(host.querySelectorAll('.rev-delta-icon')) as HTMLElement[];
    icons.forEach(i => i.remove());
  }

  private normalizeLabel(text: string): string {
    return (text || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '');
  }
}

